import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgTopbarComponent } from './pg-topbar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PgTopbarComponent],
  exports: [PgTopbarComponent],
})
export class PgTopbarModule {}
